import { render, staticRenderFns } from "./Survey.Question.Table.vue?vue&type=template&id=3013cd07&"
import script from "./Survey.Question.Table.vue?vue&type=script&lang=js&"
export * from "./Survey.Question.Table.vue?vue&type=script&lang=js&"
import style0 from "./Survey.Question.Table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VTooltip})
